"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiscordRelayMessageMessageAuthorToJSON = exports.DiscordRelayMessageMessageAuthorFromJSONTyped = exports.DiscordRelayMessageMessageAuthorFromJSON = void 0;
var runtime_1 = require("../runtime");
function DiscordRelayMessageMessageAuthorFromJSON(json) {
    return DiscordRelayMessageMessageAuthorFromJSONTyped(json, false);
}
exports.DiscordRelayMessageMessageAuthorFromJSON = DiscordRelayMessageMessageAuthorFromJSON;
function DiscordRelayMessageMessageAuthorFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'username': !(0, runtime_1.exists)(json, 'username') ? undefined : json['username'],
        'discriminator': !(0, runtime_1.exists)(json, 'discriminator') ? undefined : json['discriminator'],
        'avatar': !(0, runtime_1.exists)(json, 'avatar') ? undefined : json['avatar'],
        'bot': !(0, runtime_1.exists)(json, 'bot') ? undefined : json['bot'],
    };
}
exports.DiscordRelayMessageMessageAuthorFromJSONTyped = DiscordRelayMessageMessageAuthorFromJSONTyped;
function DiscordRelayMessageMessageAuthorToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'username': value.username,
        'discriminator': value.discriminator,
        'avatar': value.avatar,
        'bot': value.bot,
    };
}
exports.DiscordRelayMessageMessageAuthorToJSON = DiscordRelayMessageMessageAuthorToJSON;
